import { JSONAPISerializer } from '@orbit/jsonapi'

export class CustomJSONAPISerializer extends JSONAPISerializer {
  resourceKey(type) {
    return 'remoteId'
  }
}
